export default "__VITE_ASSET__B_4Xodhi__"